/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import {
  Header,
  Form,
  Button,
  Table,
  Loader,
  Message,
  Icon,
  Dimmer,
  Segment,
  Popup,
  List,
  GridColumn
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import Dropzone from 'react-dropzone';
import cx from 'classnames';
//import html2canvas from 'html2canvas';
//import jsPDF from 'jspdf';
//import fs from 'fs';
import { CSVLink } from 'react-csv';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import ResultRenderer from '../ResultRenderer/CustomResultRenderer';
import SecurityDetailModal from '../Modal/SecurityDetailModal';
import './KnowledgeBase.css';

class SearchCveCode extends Component {
  constructor(props) {
    super(props);
    this.typingTimeout = null;
    this.csvLink = React.createRef();
    this.page = React.createRef();
    const { t } = props;

    this.state = {
      componentName: '',
      componentVersionName: '',
      pageSize: 25,
      currentPage: 1,
      resultList: [],
      activeType: '',
      selectedList: [],
      cveList: [],
      cveData: {},
      excelData: [],
      selectedCode: '',
      currentCount: null,
      fileName: t('knowledgebase.message.drag_drop_guide'),
      isLoading: false,
      isScrollLoading: false,
      isOpenMSD: false,
      isCsvDownloading: false,
      isError: false,
      error: null,
      reportName: null,
      hasMore: false,
      //isPdfDownloading: false,
    };
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleClearList = this.handleClearList.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlurOnName = this.handleBlurOnName.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.handleSecurityDetailModal = this.handleSecurityDetailModal.bind(this);
    this.handleMSDClose = this.handleMSDClose.bind(this);
    //this.handlePDF = this.handlePDF.bind(this);
    this.handleExcel = this.handleExcel.bind(this);
    this.handleExpandAll = this.handleExpandAll.bind(this);
    this.handleSearchForm = this.handleSearchForm.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleOnScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleSearchForm(e) {
    const { activeType } = this.state;
    const parents = $(e.target).parent().siblings('div');

    this.setState({
      selectedList: [],
      pageSize: 25,
      resultList: [],
      activeType: '',
    });

    parents.each((index, item) => {
      if (
        activeType === 'component_name'
        && $(item).find('.nameInput').length !== 0
      ) {
        $(item).find('.nameInput').find('input').blur();
      } else if (
        activeType === 'component_version_name'
        && $(item).find('.versionInput').length !== 0
      ) {
        $(item).find('.versionInput').find('input').blur();
      }
    });

    this.getResult();
  }

  handleOnScroll() {
    const {
      getResult,
      state: {
        error, isScrollLoading, hasMore, currentPage
      },
    } = this;
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
    const { clientHeight } = document.documentElement;
    if (error || isScrollLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getResult(currentPage + 1);
    }
  }

  handleChange = (dataType, value) => {
    const { isLoading } = this.state;
    if (isLoading) {
      return;
    }

    if (dataType === 'component_name') {
      this.setState({ componentName: value, componentVersionName: '' });
    } else {
      this.setState({ componentVersionName: value });
    }

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      if (value.trim() === '') {
        this.setState({ resultList: [] });
        return;
      }

      if (dataType === 'component_name') {
        this.searchComponentName(value, dataType);
      } else if (dataType === 'component_version_name') {
        this.searchComponentVersion(value, dataType);
      }
    }, 500);
  };

  handleFocus = (dataType) => {
    this.setState({ activeType: dataType });

    const { componentName, componentVersionName } = this.state;
    let existingValue = '';

    if (dataType === 'component_name') {
      existingValue = componentName;
    } else if (dataType === 'component_version_name') {
      existingValue = componentVersionName;
    }

    if (existingValue.trim() !== '') {
      if (dataType === 'component_name') {
        this.searchComponentName(existingValue, dataType);
      } else if (dataType === 'component_version_name') {
        if (componentName.trim() !== '') {
          this.searchComponentVersion(existingValue, dataType);
        }
      }
    } else {
      this.setState({ resultList: [] });
    }
  };

  handleBlurOnName = () => {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }

    this.setState({
      activeType: '',
      resultList: [],
    });
  };

  handleResultSelect = (e, result) => {
    if (result.data_type === 'component_name') {
      this.setState({
        componentName: result.name,
        componentVersionName: '',
        activeType: '',
        resultList: [],
      });
    } else {
      this.setState({
        componentVersionName: result.name,
        activeType: '',
        resultList: [],
      });
    }
  };

  handleClearList() {
    this.setState({
      cveList: [],
      selectedList: [],
      componentName: '',
      componentVersionName: '',
      currentCount: null,
    });
  }

  handleSecurityDetailModal(e, value) {
    const data = {
      security_name: value,
    };
    api
      .getComponentSecurityDetail(data)
      .then((response) => {
        this.setState({
          cveData: response.response,
          selectedCode: value,
          isOpenMSD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleMSDClose() {
    this.setState({
      isOpenMSD: false,
    });
  }

  checkDataType = (type) => {
    if (type === '') {
      return true;
    }
    if (type === 'text/plain') {
      return true;
    }
    /*
    if (type === 'text/csv') {
      return true;
    }
    */
    return false;
  };

  onDrop = (file) => {
    const { t } = this.props;
    const data = file[0];
    const isAllow = this.checkDataType(data.type);

    if (!isAllow) {
      return this.setState(
        {
          fileName: t('knowledgebase.message.only_txt_file'),
          isError: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              fileName: t('knowledgebase.message.drag_drop_guide'),
              isError: false,
            });
          }, 1500);
        }
      );
    }

    const reader = new FileReader();

    reader.readAsText(data);

    reader.onload = () => {
      const array = reader.result.split(/[\r\n]+/gm);
      const newData = array.map((item) => {
        const newString = item.split(/[ ,]+/);
        return {
          component_name: newString[0],
          component_version: newString[1],
        };
      });

      const filtered = newData.filter((item) => {
        return item.component_name;
      });

      this.setState(
        {
          selectedList: filtered,
          pageSize: 25,
          componentName: '',
          componentVersionName: '',
        },
        () => {
          this.getResult();
        }
      );
    };

    reader.onerror = () => {
      console.log(reader.error);
    };
  };

  getResult = (pageNo, limit) => {
    const {
      componentName, componentVersionName, pageSize, selectedList
    } = this.state;
    const { t } = this.props;
    const page = pageNo || 1;
    const perPage = limit || pageSize;
    let array;

    if (selectedList.length === 0) {
      array = [];
      const selectedInfo = {
        component_name: componentName,
        component_version: componentVersionName,
      };
      array.push(selectedInfo);
    } else {
      array = selectedList;
    }

    const obj = {
      component_list: array,
      page,
      limit: perPage,
    };

    if (page === 1) {
      this.setState({
        isLoading: true,
      });
    } else {
      this.setState({
        isScrollLoading: true,
      });
    }

    api
      .searchCVECode(obj)
      .then((response) => {
        const nextCveList = response.response.map((item) => {
          return {
            component_name: item.component_name,
            component_version: item.component_version,
            security_code: item.security_code,
          };
        });

        const { cveList } = this.state;

        clearTimeout(this.typingTimeout);

        if (response.pagination.current === 1) {
          this.setState({
            //totalCount: response.count,
            currentPage: response.pagination.current,
            //prevPage: response.pagination.previous,
            //nextPage: response.pagination.next,
            pageSize: response.pagination.per_page,
            //totalPage: response.pagination.pages,
            currentCount: response.pagination.count,
            hasMore: response.pagination.next !== null,
            isLoading: false,
            cveList: nextCveList,
          });
        } else {
          this.setState({
            //totalCount: response.count,
            currentPage: response.pagination.current,
            //prevPage: response.pagination.previous,
            //nextPage: response.pagination.next,
            pageSize: response.pagination.per_page,
            //totalPage: response.pagination.pages,
            currentCount: response.pagination.count,
            hasMore: response.pagination.next !== null,
            isLoading: false,
            isScrollLoading: false,
            cveList: [...cveList, ...nextCveList],
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
          isScrollLoading: false,
          error: t('knowledgebase.error.load_error'),
          selectedList: [],
        });
      });
  };

  generateReport = (resultAll, type) => {
    const { t } = this.props;
    const { componentName, selectedList } = this.state;
    const newRowData = [];
    let fileName;
    let i = 0;

    for (i; i < resultAll.length; i++) {
      let j = 0;
      if (resultAll[i].security_code.length === 0) {
        const emptyData = {
          component_name: resultAll[i].component_name,
          component_version: resultAll[i].component_version,
          risk: '',
          code: '',
        };
        newRowData.push(emptyData);
      } else {
        for (j; j < resultAll[i].security_code.length; j++) {
          const newData = {
            component_name: resultAll[i].component_name,
            component_version: resultAll[i].component_version,
            risk: resultAll[i].security_code[j].risk,
            code: resultAll[i].security_code[j].code,
          };
          newRowData.push(newData);
        }
      }
    }

    const downloadData = [];
    let index = 0;
    const colums = [
      {
        Header: t('knowledgebase.component_name'),
        accessor: 'component_name',
      },
      {
        Header: t('knowledgebase.component_version'),
        accessor: 'component_version',
      },
      {
        Header: t('knowledgebase.cve_risk'),
        accessor: 'risk',
      },
      {
        Header: t('knowledgebase.cve_code'),
        accessor: 'code',
      },
    ];

    for (index; index < newRowData.length; index++) {
      const record = {};
      let colIndex = 0;
      for (colIndex; colIndex < colums.length; colIndex++) {
        record[colums[colIndex].Header] = newRowData[index][colums[colIndex].accessor];
      }
      downloadData.push(record);
    }

    if (type === 'single') {
      fileName = componentName;
    } else {
      const count = selectedList.length - 1;
      const name = selectedList[0].component_name;
      fileName = `${name}+${count}`;
    }

    this.setState(
      {
        excelData: downloadData,
        isCsvDownloading: false,
        reportName: fileName,
      },
      () => {
        //this.csvLink.link.click();
        this.csvLink.current.link.click();
      }
    );
  };

  searchComponentName = (searchKeyword, dataType) => {
    const { pageSize } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';

    api
      .searchPolicyComponent({
        search: newText,
        limit: pageSize,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        this.setState({
          activeType: `${dataType}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  searchComponentVersion = (searchKeyword, dataType) => {
    const { pageSize, componentName } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';

    api
      .searchPolicyVersion({
        search: newText,
        component: componentName,
        limit: pageSize,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        this.setState({
          activeType: `${dataType}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleExpandAll = () => {
    const { currentCount } = this.state;
    this.getResult(1, currentCount);
  };

  /*
  handlePDF = () => {
    const input = this.page;
    const { componentName } = this.state;

    this.setState({
      isPdfDownloading: true,
    }, () => {
      html2canvas(input)
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const imgWidth = 210;
          const pageHeight = imgWidth * 1.414;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          // eslint-disable-next-line new-cap
          const doc = new jsPDF('p', 'mm');
          let position = 0;

          // 첫 페이지 출력
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          // 한 페이지 이상일 경우 루프 돌면서 출력
          while (heightLeft >= 20) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }

          this.setState({
            isPdfDownloading: false,
          }, () => {
            doc.save(`${componentName}.pdf`);
          });
        });
    });
  };
  */

  handleExcel = () => {
    const {
      cveList,
      currentCount,
      selectedList,
      componentName,
      componentVersionName,
    } = this.state;
    const searchType = selectedList.length === 0 ? 'single' : 'multi';
    let resultAll;
    let objArray;

    this.setState(
      {
        isCsvDownloading: true,
      },
      () => {
        if (cveList.length !== currentCount) {
          if (selectedList.length === 0) {
            objArray = [];
            const selectedInfo = {
              component_name: componentName,
              component_version: componentVersionName,
            };
            objArray.push(selectedInfo);
          } else {
            objArray = selectedList;
          }

          const obj = {
            component_list: objArray,
            page: 1,
            limit: currentCount,
          };

          api
            .searchCVECode(obj)
            .then((response) => {
              const nextCveList = response.response.map((item) => {
                return {
                  component_name: item.component_name,
                  component_version: item.component_version,
                  security_code: item.security_code,
                };
              });

              resultAll = nextCveList;
              this.generateReport(resultAll, searchType);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          resultAll = cveList;
          this.generateReport(resultAll, searchType);
        }
      }
    );
  };

  numberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  render() {
    const {
      isLoading,
      componentName,
      componentVersionName,
      resultList,
      activeType,
      cveList,
      cveData,
      currentCount,
      //isPdfDownloading,
      isCsvDownloading,
      isScrollLoading,
      error,
      reportName,
      isError,
      fileName,
      excelData,
      isOpenMSD,
      selectedCode,
    } = this.state;

    const { t } = this.props;

    return (
      <GridColumn className="content knowledge">
        <Form className="knowledge_wrap">
          <Header as="h3">
            <Header.Content>
              <Popup
                trigger={<Icon name="question circle outline" />}
                content={t('knowledgebase.message.vuln_search_guide')}
                position="top left"
                size="small"
                className="question"
              />
              {t('knowledgebase.message.search_vuln_title')}
              <Header.Subheader>
                {t('knowledgebase.message.search_vuln_sub_title')}
              </Header.Subheader>
            </Header.Content>
          </Header>
          <Form.Group>
            <Form.Field>
              <Form.Input
                className="nameInput"
                type="text"
                placeholder={t('knowledgebase.place_holder.component')}
                value={componentName}
                onChange={(e) => {
                  return this.handleChange('component_name', e.target.value);
                }}
                onFocus={(e) => {
                  return this.handleFocus('component_name', e.target.value);
                }}
                onBlur={this.handleBlurOnName}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeType === 'component_name'}
                translate={t}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                type="text"
                className="versionInput"
                placeholder={t('knowledgebase.place_holder.component_version')}
                disabled={componentName === ''}
                value={componentVersionName}
                onChange={(e) => {
                  return this.handleChange(
                    'component_version_name',
                    e.target.value
                  );
                }}
                onFocus={(e) => {
                  return this.handleFocus(
                    'component_version_name',
                    e.target.value
                  );
                }}
                onBlur={this.handleBlurOnName}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeType === 'component_version_name'}
                translate={t}
              />
            </Form.Field>
            <Form.Field>
              <Form.Button
                className="search"
                style={{ width: '100px' }}
                content={t('knowledgebase.button.search')}
                disabled={componentName === ''}
                onClick={this.handleSearchForm}
              />
            </Form.Field>
          </Form.Group>
          <Header as="h3">
            <Header.Content>
              <Popup
                trigger={<Icon name="question circle outline" />}
                position="top left"
                size="small"
                className="question"
              >
                <div className="text">
                  <span className="title">
                    {t('knowledgebase.format_file_import')}
                  </span>
                  <List bulleted>
                    <List.Item>
                      {t('knowledgebase.message.guide_dropzone_txt')}
                    </List.Item>
                    <List.Item>
                      {t('knowledgebase.message.guide_dropzone_contain')}
                    </List.Item>
                    <List.Item>
                      {t('knowledgebase.message.guide_dropzone_example')}
                      :&#123;
                      {t('knowledgebase.message.guide_dropzone_component_name')}
                      &#125; &#123;
                      {t('knowledgebase.message.guide_dropzone_whitespace')}
                      &#125; &#123;
                      {t(
                        'knowledgebase.message.guide_dropzone_component_version_name'
                      )}
                      &#125;
                    </List.Item>
                    <List.Item>
                      {t('knowledgebase.message.guide_dropzone_rows')}
                    </List.Item>
                  </List>
                </div>
              </Popup>
              {t('knowledgebase.import_a_file')}
            </Header.Content>
          </Header>
          <Form.Group>
            <div className="dropzone_wrap">
              <Dropzone onDrop={this.onDrop}>
                {({ getRootProps, getInputProps }) => {
                  return (
                    <div {...getRootProps({ className: 'drop_files_here' })}>
                      <input {...getInputProps()} />
                      <span className="icon">
                        {!isError ? (
                          <Icon
                            name="cloud upload"
                            size="big"
                            style={{
                              color: '#dddddd',
                              display: 'inline-block',
                              margin: '14px',
                            }}
                          />
                        ) : (
                          <Icon
                            name="ban"
                            size="big"
                            style={{
                              color: '#dddddd',
                              display: 'inline-block',
                              margin: '14px',
                            }}
                          />
                        )}
                      </span>
                      {isError ? (
                        <p className="file_info error">{fileName}</p>
                      ) : (
                        <p className="file_info">{fileName}</p>
                      )}
                    </div>
                  );
                }}
              </Dropzone>
            </div>
          </Form.Group>
          <div className="header_wrap">
            <Header as="h3">
              <Header.Content>
                {t('knowledgebase.search_result')}
              </Header.Content>
            </Header>
            <div className="btn_wrap">
              <Button
                className="clear_btn"
                content={t('knowledgebase.button.clear')}
                disabled={cveList.length === 0}
                onClick={this.handleClearList}
              />
              <Button
                className="view_all_btn"
                content={t('knowledgebase.button.view_all')}
                disabled={cveList.length === 0}
                loading={isLoading}
                onClick={this.handleExpandAll}
              />
              <Button
                className="csv_btn"
                content="CSV"
                disabled={cveList.length === 0}
                loading={isCsvDownloading}
                onClick={this.handleExcel}
              />
              {/*<Button className="pdf_btn" content="PDF (TEST)" disabled={cveList.length === 0} loading={isPdfDownloading} onClick={this.handlePDF} />*/}
            </div>
          </div>
          <Form.Group>
            <div className="result_wrap">
              {isLoading ? (
                <div style={{ height: '140px', position: 'relative' }}>
                  <Loader size="large" style={{ display: 'block' }} />
                </div>
              ) : (
                <div className="contents_wrap" ref={this.page}>
                  {cveList.length !== 0 && (
                    <Table celled structured>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>
                            {t('knowledgebase.component')}
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                            {t('knowledgebase.component_version')}
                            {currentCount
                              ? `(${this.numberWithCommas(currentCount)})`
                              : null}
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                            {t('knowledgebase.cve_code')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {cveList.map((item) => {
                          if (item.security_code.length === 0) {
                            return (
                              <Table.Row key={uuidv4()}>
                                <Table.Cell>{item.component_name}</Table.Cell>
                                <Table.Cell>
                                  {item.component_version}
                                </Table.Cell>
                                <Table.Cell />
                              </Table.Row>
                            );
                          }
                          return item.security_code.map((nest, k) => {
                            if (k === 0) {
                              return (
                                <Table.Row key={uuidv4()}>
                                  <Table.Cell
                                    rowSpan={item.security_code.length}
                                  >
                                    {item.component_name}
                                  </Table.Cell>
                                  <Table.Cell
                                    rowSpan={item.security_code.length}
                                  >
                                    {item.component_version}
                                  </Table.Cell>
                                  <Table.Cell
                                    className={cx(
                                      'bullet has_link',
                                      {
                                        bullet_red: nest.risk === 'critical',
                                      },
                                      {
                                        bullet_orange: nest.risk === 'high',
                                      },
                                      {
                                        bullet_cheese: nest.risk === 'medium',
                                      },
                                      {
                                        bullet_yellow: nest.risk === 'low',
                                      }
                                    )}
                                  >
                                    <span
                                      onClick={(e) => {
                                        return this.handleSecurityDetailModal(
                                          e,
                                          nest.code
                                        );
                                      }}
                                      onKeyUp={(e) => {
                                        return this.handleSecurityDetailModal(
                                          e,
                                          nest.code
                                        );
                                      }}
                                    >
                                      {nest.code}
                                    </span>
                                  </Table.Cell>
                                </Table.Row>
                              );
                            }
                            return (
                              <Table.Row key={uuidv4()}>
                                <Table.Cell
                                  className={cx(
                                    'bullet has_link',
                                    {
                                      bullet_red: nest.risk === 'critical',
                                    },
                                    {
                                      bullet_orange: nest.risk === 'high',
                                    },
                                    {
                                      bullet_cheese: nest.risk === 'medium',
                                    },
                                    {
                                      bullet_yellow: nest.risk === 'low',
                                    }
                                  )}
                                >
                                  <span
                                    onClick={(e) => {
                                      return this.handleSecurityDetailModal(
                                        e,
                                        nest.code
                                      );
                                    }}
                                    onKeyUp={(e) => {
                                      return this.handleSecurityDetailModal(
                                        e,
                                        nest.code
                                      );
                                    }}
                                  >
                                    {nest.code}
                                  </span>
                                </Table.Cell>
                              </Table.Row>
                            );
                          });
                        })}
                      </Table.Body>
                    </Table>
                  )}
                  {cveList.length === 0 && (
                    <Message warning style={{ display: 'block' }}>
                      <Message.Header>
                        {t('knowledgebase.message.no_results_found')}
                      </Message.Header>
                    </Message>
                  )}
                  {error && <div className="error_log">{error}</div>}
                  {isScrollLoading && (
                    <Segment>
                      <Dimmer active inverted style={{ position: 'relative' }}>
                        <Loader
                          size="medium"
                          style={{ lineHeight: '15px', position: 'absolute' }}
                        >
                          Loading
                        </Loader>
                      </Dimmer>
                    </Segment>
                  )}
                  <div>
                    <CSVLink
                      data={excelData}
                      filename={`${reportName}.csv`}
                      className="hidden"
                      ref={this.csvLink}
                      target="_blank"
                    />
                  </div>
                </div>
              )}
            </div>
          </Form.Group>
        </Form>
        <SecurityDetailModal
          isOpenMSD={isOpenMSD}
          closeModal={this.handleMSDClose}
          cveData={cveData}
          selectedCode={selectedCode}
        />
      </GridColumn>
    );
  }
}
export default withTranslation()(SearchCveCode);
